var map = {
	"./sch-1.jpg": 131,
	"./sch-2.jpg": 132,
	"./sch-3.jpg": 133,
	"./sch-4.jpg": 134,
	"./sch-5.jpg": 135,
	"./sch-6.jpg": 136,
	"./scholarship-1.jpg": 137,
	"./scholarship-2.jpg": 138,
	"./scholarship-3.jpg": 139,
	"./scholarship-4.jpg": 140,
	"./scholarship-5.jpg": 141,
	"./scholarship-6.jpg": 142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1374;